import React, { FC } from "react";
import "styles/checkbox.scss";
import { CheckboxProps } from "types/atoms.types";

const Checkbox: FC<CheckboxProps> = ({
  title,
  inputId,
  name,
  onChange,
  disabled,
  ischecked,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
  };

  return (
    <div className="asr-checkbox">
      <div>
        <input
          id={inputId}
          type="checkbox"
          checked={ischecked}
          value={ title === 'Category' ? name : inputId}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>
      <label htmlFor={inputId}>{name}</label>
    </div>
  );
};

export default Checkbox;
